<template>
	<div>
		<v-card>
			<v-card-title class="d-flex align-center">
				<v-icon
					icon="$cloudDownload"
					start
				/>
				<translate>Download Settlement Reports</translate>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col>
						<model-backend-table
							endpoint="/api/v0/adyennotifications/reports"
							:headers="tableHeaders"
							:items-per-page-options="[10,25,50]"
						>
							<template #item.pspReference="{ item }">
								<a
									:href="`/api/v0/adyennotifications/download?psp_reference=${item.pspReference}`"
								>
									{{ item.pspReference }}
								</a>
							</template>
						</model-backend-table>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
export default {
	name: 'DownloadSettlementReportTable',

	computed: {
		tableHeaders () {
			return [
				{
					title: this.$gettext('Date'), value: 'eventDate', sortable: false,
				},
				{
					title: this.$gettext('File Name'), value: 'pspReference', sortable: false,
				},
			];
		}
	},
};

</script>
